let pending;

export function requestPasswordStepUp() {
  if (!pending) {
    let resolve, reject;
    const promise = new Promise((yes, no) => { resolve = yes; reject = no; });
    // Write requests keep their failure and wait for the user to submit again.
    promise.catch(() => {});
    pending = { promise, resolve, reject };
    window.dispatchEvent(new Event('ail-password-required'));
  }
  return pending.promise;
}

export function finishPasswordStepUp(success) {
  const current = pending;
  pending = undefined;
  if (!current) return;
  if (success) current.resolve();
  else current.reject(new Error('密码验证已取消，编辑内容仍保留'));
}
